module.exports = __webpack_public_path__ + "static/media/clients-04.28897cb4.svg";